export const pick = function (obj, keys) {
  const result = {};

  keys.forEach((key) => {
    const parts = key.split("."); // Split nested keys
    let current = obj;
    let currentResult = result;

    // Traverse the key path
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];

      if (current && part in current) {
        if (i === parts.length - 1) {
          // Assign value at the leaf node
          currentResult[part] = current[part];
        } else {
          // Create nested structure in result if it doesn't exist
          currentResult[part] = currentResult[part] || {};
          currentResult = currentResult[part];
        }
        current = current[part];
      } else {
        break; // Stop if a part of the key path doesn't exist
      }
    }
  });

  return result;
};

export function parseBoolean(value) {
  if (typeof value === "boolean") return value;

  if (typeof value === "string") {
    switch (value.trim().toLowerCase()) {
      case "true":
      case "1":
      case "yes":
      case "on":
        return true;
      case "false":
      case "0":
      case "no":
      case "off":
        return false;
    }
  }

  if (typeof value === "number") {
    return value !== 0;
  }

  return false; // Default fallback
}

/**
 * Parses integers safely. Returns `null` if invalid.
 */
export function parseIntSafe(value, defaultValue = null) {
  const parsed = parseInt(typeof value === "string" ? value.trim() : value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
}

/**
 * Parses floats safely. Returns `null` if invalid.
 */
export function parseFloatSafe(value, defaultValue = null) {
  const parsed = parseFloat(typeof value === "string" ? value.trim() : value);
  return isNaN(parsed) ? defaultValue : parsed;
}

export function normalizeAndalePluginsPublicData() {
  // Normalize scalar values
  window.andalePluginsStockNotificationsPublic.userId = parseInt(
    window.andalePluginsStockNotificationsPublic.userId,
  );

  // Normalize settings booleans
  window.andalePluginsStockNotificationsPublic.settings.isBackInStockEnabled =
    parseBoolean(
      window.andalePluginsStockNotificationsPublic.settings
        .isBackInStockEnabled,
    );
  window.andalePluginsStockNotificationsPublic.settings.isBackInStockAutoInject =
    parseBoolean(
      window.andalePluginsStockNotificationsPublic.settings
        .isBackInStockAutoInject,
    );
  window.andalePluginsStockNotificationsPublic.settings.isPriceDropEnabled =
    parseBoolean(
      window.andalePluginsStockNotificationsPublic.settings.isPriceDropEnabled,
    );
  window.andalePluginsStockNotificationsPublic.settings.isPriceDropAutoInject =
    parseBoolean(
      window.andalePluginsStockNotificationsPublic.settings
        .isPriceDropAutoInject,
    );
}

export default {
  pick,
  parseBoolean,
  parseIntSafe,
};
